import { connect } from "react-redux";
import { useState, useEffect, useMemo } from "react";

import { ChevronDownIcon } from "@heroicons/react/20/solid";
import JournalConditionsWhen from "./JournalConditionsWhen";
import JournalConditionsSet from "./JournalConditionsSet";

const JournalConditions = ({
	when,
	set,
	rowIndex,
}) => {

	return (
		<>
			<div
				className="col-xs-12"
				style={{
					padding: 20,
					paddingRight: 0,
					paddingLeft: 0,
					background: rowIndex % 2 === 0 ? "transparent" : "#f9f9f9",
					borderRadius: 5,
				}}
			>

				<div className="col-xs-6">
					{
						when?.map((whenPart, index) => {
							return (
								<JournalConditionsWhen
									key={index}
									partIndex={index}
									lastPart={when.length - 1 === index}
									rowIndex={rowIndex}
								/>
							);
						})
					}
				</div>
				<div className="col-xs-6">
					{
						set?.map((setPart, index) => {
							return (
								<JournalConditionsSet
									key={index}
									partIndex={index}
									lastPart={set.length - 1 === index}
									rowIndex={rowIndex}
								/>
							);
						})
					}
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state, ownProps) => {

	const data = ownProps.data || {};

	const when = data?.when || [{}];
	const set = data?.set || [{}];

	return {
		when,
		set
	}
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(JournalConditions);
